import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';

import style from './style.module.css';

/**
 * Stateless component for search result table head.
 *
 * @param props {Object}.
 * @param props.companiesCount {number} Number of company in searching result.
 * @param props.peopleCount {number} Number of person in searching result.
 * @param props.onTabChange {function} Function for handling tab change.
 * @param props.activeTab {string} Name of the current active tab.
 */
const SearchResultHeadComponent = ({ hasAccess, companiesCount, peopleCount, onTabChange, activeTab }) => (
  <div className={style.host} role="tablist">
    <button
      aria-selected={activeTab === 'companies'}
      className={classNames(style.tab, { [style.active]: activeTab === 'companies' })}
      onClick={() => onTabChange('companies')}
      role="tab"
      type="button"
    >
      Companies <span className={style.count}>{companiesCount}</span>
    </button>
    {hasAccess && (
      <button
        aria-selected={activeTab === 'people'}
        className={classNames(style.tab, { [style.active]: activeTab === 'people' })}
        onClick={() => onTabChange('people')}
        role="tab"
        type="button"
      >
        People <span className={style.count}>{peopleCount}</span>
      </button>
    )}
  </div>
);

SearchResultHeadComponent.propTypes = {
  activeTab: PropTypes.string.isRequired,
  companiesCount: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
  peopleCount: PropTypes.number.isRequired,
};

export const SearchResultHead = memo(SearchResultHeadComponent);
